module.exports = __webpack_public_path__ + "img/stadion.b1bee33c.png";